import React from "react";
import { Navigate } from "react-router-dom";
import { permissionAllowsPath } from "./utils/userProfile";

const ProtectedRoute = ({ children, allowedUsers }) => {
  const username = localStorage.getItem("username");
  const token = localStorage.getItem("authToken");

  if (!username || !token) {
    return <Navigate to="/login" replace />;
  }

  const grantedDashboards = JSON.parse(
    localStorage.getItem("grantedDashboards") || "[]"
  );
  const hasGrantedAccess = grantedDashboards.some(
    (d) => d.path === window.location.pathname
  );

  // بوكسات الصلاحيات (واجهة صلاحية المستخدمين) تفتح صفحاتها أيضاً
  const hasPermissionAccess = permissionAllowsPath(window.location.pathname);

  if (!allowedUsers.includes(username) && !hasGrantedAccess && !hasPermissionAccess) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
